export default "__VITE_ASSET__bc7d7c14__"